// Navigation Routes Configuration
export const mainNavItems = [
  {
    label: 'Home',
    href: '/',
    children: [],
  },
  {
    label: 'About',
    href: '/about',
    children: [
      { label: 'Company Overview', href: '/about' },
      { label: 'Managing Director Message', href: '/managing-director-message' },
      { label: 'Vision, Mission & Values', href: '/vision-mission-values' },
      { label: 'Our Team', href: '/team' },
      { label: 'Certifications', href: '/certifications' },
      { label: 'Achievements Timeline', href: '/timeline' },
    ],
  },
  {
    label: 'Services',
    href: '/services',
    children: [
      { label: 'Government Projects', href: '/services' },
      { label: 'Digital Transformation', href: '/services' },
      { label: 'Education Technology', href: '/services' },
      { label: 'Healthcare Solutions', href: '/services' },
      { label: 'Infrastructure Development', href: '/services' },
    ],
  },
  {
    label: 'Products',
    href: '/products',
    children: [
      { label: 'Software Solutions', href: '/products' },
      { label: 'Infrastructure Products', href: '/products' },
    ],
  },
  {
    label: 'Projects',
    href: '/projects',
    children: [],
  },
  {
    label: 'Contact',
    href: '/contact',
    children: [],
  },
]

export const footerLinks = {
  company: [
    { label: 'About Us', href: '/about' },
    { label: 'Our Team', href: '/team' },
    { label: 'Vision & Mission', href: '/vision-mission-values' },
    { label: 'Certifications', href: '/certifications' },
    { label: 'Careers', href: '#' },
  ],
  services: [
    { label: 'Government Projects', href: '/services' },
    { label: 'Digital Transformation', href: '/services' },
    { label: 'Education Technology', href: '/services' },
    { label: 'Healthcare Solutions', href: '/services' },
    { label: 'Cloud Services', href: '/services' },
  ],
  products: [
    { label: 'Software Solutions', href: '/products' },
    { label: 'Infrastructure Products', href: '/products' },
    { label: 'Office Furniture', href: '/products' },
    { label: 'Lab Equipment', href: '/products' },
  ],
  resources: [
    { label: 'Case Studies', href: '/projects' },
    { label: 'Methodology', href: '/methodology' },
    { label: 'Partners', href: '/partners' },
    { label: 'Blog', href: '#' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms of Service', href: '#' },
    { label: 'Cookie Policy', href: '#' },
  ],
}

export const certifications = [
  { name: 'ISO 9001:2015 IAF-3', description: 'Quality Management' },
  { name: 'ISO 14001:2015 IAF', description: 'Environmental Management' },
  { name: 'ISO 45001:2018 IAF', description: 'Occupational Health & Safety' },
  { name: 'ISO 50001', description: 'Energy Management' },
  { name: 'ISO 20000-1:2018', description: 'IT Service Management' },
  { name: 'ISO 27001:2013', description: 'Information Security' },
  { name: 'AIOTA', description: 'Industry Association' },
  { name: 'BIFMA', description: 'Business Furniture Standards' },
  { name: 'Green Pro', description: 'Eco-Friendly Products' },
  { name: 'Green Guard', description: 'Environmental Certification' },
]

export const contactInfo = {
  phone: ['+91 8390101555'],
  email: 'info@eonixa.in',
  address: {
    street: 'Sky Iris, Bavdhan',
    city: 'Pune',
    state: 'Maharashtra',
    zip: '411001',
    country: 'India',
  },
  operationalArea: 'Across Maharashtra (expanding pan-India)',
  social: {
    linkedin: 'https://linkedin.com/company/eonixa-dynamics',
    twitter: 'https://twitter.com/eonixadynamics',
  },
}
